import { CmsValue } from 'core/type/BootstrapConfig.types';
import { createSelector } from '@reduxjs/toolkit';
import { selectActivityContentLocale, selectActivityFromDetailState } from 'component/page/detail/store/detail.selectors';
import { selectCmsFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { mapTitleFromContent } from 'gql/service/graph/activityService';

export interface BreadcrumbStateProps {
    title: string;
    cms: CmsValue;
    activityId: number;
    categoryId: string | undefined;
    isPageContainerSpacing: boolean;
}
export const mapStateToProps = createSelector(
    selectActivityFromDetailState,
    selectActivityContentLocale,
    selectCmsFromBootstrap,
    selectFeatureBehaviorFromBootstrap,
    (activity, contentLocale, cms, feature): BreadcrumbStateProps => {
        const activityContent = activity.content || {};
        const title = mapTitleFromContent(activityContent);
        const activityId = activity.masterActivityId || 0;
        const categoryId = activityContent?.activity?.categories?.[0];
        return {
            title,
            cms,
            activityId,
            categoryId,
            isPageContainerSpacing: feature.PageContainerSpacing || false,
        };
    },
);
